import { fetchCurrentUser } from '../../ducks/user.duck';
import { onGroupFolderCollectionCreate, onGroupFolderCollectionFind, onGroupFolderCollectionUpdate, onGroupFolderDocumentCollectionFind, onGroupFolderDocumentCollectionUpdate, onGroupPaymentCollectionCreate, onGroupPaymentCollectionFind, onGroupPaymentCollectionUpdate, fetchPublicPostsApi, fetchPublicCommentsApi, fetchPublicSpaceApi } from '../../util/api';
import { storableError } from '../../util/errors';
import { GROUP_PAYMENT_STATUS_ACTIVE } from '../../util/types';
import { parse } from '../../util/urlHelpers';
import { fetchAdminModerator } from '../AdminPanelModeratorsPage/AdminPanelModeratorsPage.duck';
import { findGroupJoin } from '../DiscoverGroupsCommunityPage/DiscoverGroupsCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/MyGroupCommunityPageForUnknownUser/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/MyGroupCommunityPageForUnknownUser/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/MyGroupCommunityPageForUnknownUser/ERROR_SPACE_DETAILS';

export const CREATE_FOLDER_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/CREATE_FOLDER_REQUEST';
export const CREATE_FOLDER_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_ERROR = 'app/MyGroupCommunityPageForUnknownUser/CREATE_FOLDER_ERROR';

export const UPDATE_FOLDER_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_FOLDER_REQUEST';
export const UPDATE_FOLDER_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_FOLDER_SUCCESS';
export const UPDATE_FOLDER_ERROR = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_FOLDER_ERROR';

export const FETCH_FOLDER_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/FETCH_FOLDER_REQUEST';
export const FETCH_FOLDER_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_ERROR = 'app/MyGroupCommunityPageForUnknownUser/FETCH_FOLDER_ERROR';

export const UPDATE_FOLDER_DOCUMENT_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_FOLDER_DOCUMENT_REQUEST';
export const UPDATE_FOLDER_DOCUMENT_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_FOLDER_DOCUMENT_SUCCESS';
export const UPDATE_FOLDER_DOCUMENT_ERROR = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_FOLDER_DOCUMENT_ERROR';

export const FETCH_FOLDER_DOCUMENT_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/FETCH_FOLDER_DOCUMENT_REQUEST';
export const FETCH_FOLDER_DOCUMENT_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/FETCH_FOLDER_DOCUMENT_SUCCESS';
export const FETCH_FOLDER_DOCUMENT_ERROR = 'app/MyGroupCommunityPageForUnknownUser/FETCH_FOLDER_DOCUMENT_ERROR';

export const FETCH_GROUP_PAYMENT_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/FETCH_GROUP_PAYMENT_REQUEST';
export const FETCH_GROUP_PAYMENT_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/FETCH_GROUP_PAYMENT_SUCCESS';
export const FETCH_GROUP_PAYMENT_ERROR = 'app/MyGroupCommunityPageForUnknownUser/FETCH_GROUP_PAYMENT_ERROR';

export const CREATE_GROUP_PAYMENT_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/CREATE_GROUP_PAYMENT_REQUEST';
export const CREATE_GROUP_PAYMENT_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/CREATE_GROUP_PAYMENT_SUCCESS';
export const CREATE_GROUP_PAYMENT_ERROR = 'app/MyGroupCommunityPageForUnknownUser/CREATE_GROUP_PAYMENT_ERROR';

export const UPDATE_GROUP_PAYMENT_REQUEST = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_GROUP_PAYMENT_REQUEST';
export const UPDATE_GROUP_PAYMENT_SUCCESS = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_GROUP_PAYMENT_SUCCESS';
export const UPDATE_GROUP_PAYMENT_ERROR = 'app/MyGroupCommunityPageForUnknownUser/UPDATE_GROUP_PAYMENT_ERROR';

// Public comments actions
export const PUBLIC_REQUEST_POST_COMMENT_LIST = 'app/MyGroupCommunityPageForUnknownUser/PUBLIC_REQUEST_POST_COMMENT_LIST';
export const PUBLIC_SUCCESS_POST_COMMENT_LIST = 'app/MyGroupCommunityPageForUnknownUser/PUBLIC_SUCCESS_POST_COMMENT_LIST';
export const PUBLIC_ERROR_POST_COMMENT_LIST = 'app/MyGroupCommunityPageForUnknownUser/PUBLIC_ERROR_POST_COMMENT_LIST';


const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,
  createFolderRequest: false,
  createFolderError: false,
  updateFolderRequest: false,
  updateFolderError: false,
  fetchFolderRequest: false,
  fetchFolderError: false,
  allGroupFolders: null,
  fetchFolderDocumentRequest: false,
  fetchFolderDocumentError: false,
  allFolderDocuments: null,
  updateFolderDocumentRequest: false,
  updateFolderDocumentError: false,
  totalDocumentCount: 0,
  fetchGroupPaymentRequest: false,
  fetchGroupPaymentError: false,
  allGroupPayments: null,
  createGroupPaymentRequest: false,
  createGroupPaymentError: false,
  updateGroupPaymentRequest: false,
  updateGroupPaymentError: false,
  // public comments state
  requestPostCommentList: false,
  loadMoreComments: false,
  postCommentListData: null,
  errorPostCommentList: null,
};

export const FOLDER_DOCUMENT_PAGE_SIZE = 5;
export const GROUP_PAYMENT_PAGE_SIZE = 10;

export default function myGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

    case CREATE_FOLDER_REQUEST:
      return { ...state, createFolderRequest: payload, createFolderError: null };
    case CREATE_FOLDER_SUCCESS:
      return { ...state, createFolderRequest: false, createFolderError: null };
    case CREATE_FOLDER_ERROR:
      return {
        ...state,
        createFolderRequest: false,
        createFolderError: true,
      };

    case UPDATE_FOLDER_REQUEST:
      return { ...state, updateFolderRequest: payload, updateFolderError: null };
    case UPDATE_FOLDER_SUCCESS:
      return { ...state, updateFolderRequest: false, updateFolderError: null };
    case UPDATE_FOLDER_ERROR:
      return {
        ...state,
        updateFolderRequest: false,
        updateFolderError: true,
      };

    case FETCH_FOLDER_REQUEST:
      return { ...state, fetchFolderRequest: true, fetchFolderError: null };
    case FETCH_FOLDER_SUCCESS:
      return {
        ...state,
        fetchFolderRequest: false,
        fetchFolderError: null,
        allGroupFolders: payload.data,
        totalDocumentCount: payload.pagination.documentCount,
      };
    case FETCH_FOLDER_ERROR:
      return {
        ...state,
        fetchFolderRequest: false,
        fetchFolderError: true,
      };

    case UPDATE_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state, updateFolderDocumentRequest: payload,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, updateFolderDocumentRequest: false,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        updateFolderDocumentRequest: false,
        updateFolderDocumentError: true,
      };

    case FETCH_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state,
        fetchFolderDocumentRequest: true,
        fetchFolderDocumentError: false,
        allFolderDocuments: null,
      };
    case FETCH_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: false,
        allFolderDocuments: payload,
      };
    case FETCH_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: true,
        allFolderDocuments: null,
      };

    case UPDATE_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state, updateFolderDocumentRequest: payload,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, updateFolderDocumentRequest: false,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        updateFolderDocumentRequest: false,
        updateFolderDocumentError: true,
      };

    case FETCH_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state,
        fetchFolderDocumentRequest: true,
        fetchFolderDocumentError: false,
        allFolderDocuments: null,
      };
    case FETCH_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: false,
        allFolderDocuments: payload,
      };
    case FETCH_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: true,
        allFolderDocuments: null,
      };

    case FETCH_GROUP_PAYMENT_REQUEST:
      return { ...state, fetchGroupPaymentRequest: true, fetchGroupPaymentError: false, allGroupPayments: null };
    case FETCH_GROUP_PAYMENT_SUCCESS:
      return { ...state, fetchGroupPaymentRequest: false, fetchGroupPaymentError: false, allGroupPayments: payload };
    case FETCH_GROUP_PAYMENT_ERROR:
      return { ...state, fetchGroupPaymentRequest: false, fetchGroupPaymentError: true, allGroupPayments: null };

    case CREATE_GROUP_PAYMENT_REQUEST:
      return { ...state, createGroupPaymentRequest: payload, createGroupPaymentError: false };
    case CREATE_GROUP_PAYMENT_SUCCESS:
      return { ...state, createGroupPaymentRequest: false, createGroupPaymentError: false };
    case CREATE_GROUP_PAYMENT_ERROR:
      return { ...state, createGroupPaymentRequest: false, createGroupPaymentError: true };

    case UPDATE_GROUP_PAYMENT_REQUEST:
      return { ...state, updateGroupPaymentRequest: payload, updateGroupPaymentError: false };
    case UPDATE_GROUP_PAYMENT_SUCCESS:
      return { ...state, updateGroupPaymentRequest: false, updateGroupPaymentError: false };
    case UPDATE_GROUP_PAYMENT_ERROR:
      return { ...state, updateGroupPaymentRequest: false, updateGroupPaymentError: true };

    case PUBLIC_REQUEST_POST_COMMENT_LIST:
      return { ...state, requestPostCommentList: payload.page <= 1, loadMoreComments: payload.page > 1 };
    case PUBLIC_SUCCESS_POST_COMMENT_LIST: {
      const { data } = payload;
      const { page, records = [] } = data || {};
      return {
        ...state,
        requestPostCommentList: false,
        loadMoreComments: false,
        postCommentListData: page > 1 && state.postCommentListData
          ? { ...data, records: [...(state.postCommentListData.records || []), ...records] }
          : data,
      };
    }
    case PUBLIC_ERROR_POST_COMMENT_LIST:
      return { ...state, requestPostCommentList: false, loadMoreComments: false, errorPostCommentList: payload.error };

      default:
      return state;
  }
}

export const requestSpaceDetails = () => ({
  type: REQUEST_SPACE_DETAILS,
});
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});

export const publicRequestPostCommentList = (page = 1) => ({
  type: PUBLIC_REQUEST_POST_COMMENT_LIST,
  payload: { page },
});

export const publicSuccessPostCommentList = data => ({
  type: PUBLIC_SUCCESS_POST_COMMENT_LIST,
  payload: { data },
});

export const publicErrorPostCommentList = error => ({
  type: PUBLIC_ERROR_POST_COMMENT_LIST,
  payload: { error },
});

export const fetchPublicPostCommentList = ({ postId, spaceId, page = 1, per_page = 10 }) => async dispatch => {
  try {
    console.log("12345678")
    dispatch(publicRequestPostCommentList(page));
    const response = await fetchPublicCommentsApi({ post_id: postId, space_id: spaceId, page, per_page });
    console.log("response",response)
    // Normalize to expected shape: { page, per_page, has_next_page, count, records }
    const toWithPostId = recs => (recs || []).map(r => ({
      ...r,
      post_id: r?.post_id || r?.post?.id || r?.postId || null,
    }));

    const normalized = Array.isArray(response)
      ? { page, per_page, has_next_page: false, count: response.length, records: toWithPostId(response) }
      : response?.records
        ? { ...response, records: toWithPostId(response.records) }
        : { page, per_page, has_next_page: !!response?.has_next_page, count: response?.count || 0, records: toWithPostId(response?.records || []) };
    dispatch(publicSuccessPostCommentList(normalized));
    return response;
  } catch (e) {
    const err = storableError(e);
    dispatch(publicErrorPostCommentList(err));
    throw err;
  }
};


export const createFolderRequest = (data) => ({
  type: CREATE_FOLDER_REQUEST,
  payload: data,
});
export const createFolderSuccess = data => ({
  type: CREATE_FOLDER_SUCCESS,
  payload: data,
});
export const createFolderError = error => ({
  type: CREATE_FOLDER_ERROR,
  payload: error,
});

export const updateFolderRequest = (data) => ({
  type: UPDATE_FOLDER_REQUEST,
  payload: data,
});
export const updateFolderSuccess = data => ({
  type: UPDATE_FOLDER_SUCCESS,
  payload: data,
});
export const updateFolderError = error => ({
  type: UPDATE_FOLDER_ERROR,
  payload: error,
});

export const fetchFolderRequest = () => ({
  type: FETCH_FOLDER_REQUEST,
});
export const fetchFolderSuccess = data => ({
  type: FETCH_FOLDER_SUCCESS,
  payload: data,
});
export const fetchFolderError = error => ({
  type: FETCH_FOLDER_ERROR,
  payload: error,
});


export const fetchFolderDocumentRequest = () => ({
  type: FETCH_FOLDER_DOCUMENT_REQUEST,
});
export const fetchFolderDocumentSuccess = data => ({
  type: FETCH_FOLDER_DOCUMENT_SUCCESS,
  payload: data,
});
export const fetchFolderDocumentError = error => ({
  type: FETCH_FOLDER_DOCUMENT_ERROR,
  payload: error,
});

export const updateFolderDocumentRequest = (data) => ({
  type: UPDATE_FOLDER_DOCUMENT_REQUEST,
  payload: data,
});
export const updateFolderDocumentSuccess = data => ({
  type: UPDATE_FOLDER_DOCUMENT_SUCCESS,
  payload: data,
});
export const updateFolderDocumentError = error => ({
  type: UPDATE_FOLDER_DOCUMENT_ERROR,
  payload: error,
});

export const fetchGroupPaymentRequest = () => ({
  type: FETCH_GROUP_PAYMENT_REQUEST,
});
export const fetchGroupPaymentSuccess = data => ({
  type: FETCH_GROUP_PAYMENT_SUCCESS,
  payload: data,
});

export const fetchGroupPaymentError = error => ({
  type: FETCH_GROUP_PAYMENT_ERROR,
  payload: error,
});

export const createGroupPaymentRequest = (payload) => ({
  type: CREATE_GROUP_PAYMENT_REQUEST,
  payload:payload
});
export const createGroupPaymentSuccess = data => ({
  type: CREATE_GROUP_PAYMENT_SUCCESS,
  payload: data,
});

export const createGroupPaymentError = error => ({
  type: CREATE_GROUP_PAYMENT_ERROR,
  payload: error,
});

export const updateGroupPaymentRequest = (data) => ({
  type: UPDATE_GROUP_PAYMENT_REQUEST,
  payload:data
});
export const updateGroupPaymentSuccess = data => ({
  type: UPDATE_GROUP_PAYMENT_SUCCESS,
  payload: data,
});
export const updateGroupPaymentError = error => ({
  type: UPDATE_GROUP_PAYMENT_ERROR,
  payload: error,
});


export const fetchGroupPayment = (params,data) => async (dispatch, getState) => {
  dispatch(fetchGroupPaymentRequest());
  return onGroupPaymentCollectionFind({...params, data })
    .then((response) => {
      dispatch(fetchGroupPaymentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "fetchGroupPayment >>>> storableError(e)")
      dispatch(fetchGroupPaymentError(storableError(e)));
    });
};

export const createGroupPayment = (params,type) => async (dispatch, getState) => {
  dispatch(createGroupPaymentRequest(type));
  return onGroupPaymentCollectionCreate(params)
    .then((response) => {
      dispatch(createGroupPaymentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupPayment >>>> storableError(e)")
      dispatch(createGroupPaymentError(storableError(e)));
      return e;
    });
};


export const updateGroupPayment = (params,loader) => async (dispatch, getState) => {
  dispatch(updateGroupPaymentRequest(loader));
  return onGroupPaymentCollectionUpdate(params)
    .then((response) => {
      dispatch(updateGroupPaymentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "updateGroupPayment >>>> storableError(e)")
      dispatch(updateGroupPaymentError(storableError(e)));
      return e;
    });
};


export const createGroupFolder = (params, groupId) => async (dispatch, getState) => {
  dispatch(createFolderRequest("create"));
  return onGroupFolderCollectionCreate(params)
    .then(async (response) => {
      await dispatch(fetchGroupFolder({
        payload: {
          groupId: groupId,
          isActive: true,
          isDelete: false
        }
      }))
      dispatch(createFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(createFolderError(storableError(e)));
    });
};

export const updateGroupFolder = (params, groupId) => async (dispatch, getState) => {
  const type = !!params.payload.isDelete ? "delete" : "update"
  dispatch(updateFolderRequest(type));
  return onGroupFolderCollectionUpdate(params)
    .then(async (response) => {
      await dispatch(fetchGroupFolder({
        payload: {
          groupId: groupId,
          isActive: true,
          isDelete: false
        }
      }))
      dispatch(updateFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(updateFolderError(storableError(e)));
    });
};

export const fetchGroupFolder = (params) => async (dispatch, getState) => {
  dispatch(fetchFolderRequest());
  return onGroupFolderCollectionFind(params)
    .then((response) => {
      dispatch(fetchFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(fetchFolderError(storableError(e)));
    });
};


export const updateGroupDocumentFolder = (params, fetchData) => async (dispatch, getState) => {
  dispatch(updateFolderDocumentRequest(params.id));
  return onGroupFolderDocumentCollectionUpdate(params)
    .then(async (response) => {
      await dispatch(fetchGroupDocumentFolder(fetchData))
      dispatch(updateFolderDocumentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(updateFolderDocumentError(storableError(e)));
    });
};

export const fetchGroupDocumentFolder = (params) => async (dispatch, getState) => {
  dispatch(fetchFolderDocumentRequest());
  return onGroupFolderDocumentCollectionFind(params)
    .then((response) => {
      dispatch(fetchFolderDocumentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(fetchFolderDocumentError(storableError(e)));
    });
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { page = 1, topicId } = parse(search);

  dispatch(requestSpaceDetails(page));

  try {
    // Public endpoint to fetch posts and related details without requiring auth
    const postsResponsePromise = fetchPublicPostsApi({
      // server expects keys: space_id, page, per_page, search_text, status, sort
      space_id: params.id,
      page: Number(page),
      per_page: 20,
      sort: 'latest',
      status: 'published',
      // topic filter not supported in public endpoint; ignoring topicId here
    });

    // Fetch space details for banner (name, cover image)
    const spaceResponsePromise = fetchPublicSpaceApi({ space_id: params.id });

    const [postsResponse, spaceResponse] = await Promise.all([
      postsResponsePromise,
      spaceResponsePromise,
    ]);

    // Normalize to expected shape for UI consumption
    const normalized = {
      spaceDetail: {
        id: params.id,
        slug: params.slug,
        name: spaceResponse?.name || spaceResponse?.display_name || '',
        cover_image_url: spaceResponse?.cover_image_url || spaceResponse?.cover_image?.url || '',
        is_member: false,
        policies: {},
        is_private: !!spaceResponse?.is_private,
      },
      postResponse: postsResponse,
      topicResponse: null,
    };

    dispatch(successSpaceDetails(normalized));
    return normalized;
  } catch (e) {
    dispatch(errorSpaceDetails(storableError(e)));
    throw e;
  }
};
